import { styled } from '../theme';

const PageCard = styled('div')<{ transparentSurface?: boolean }>(
    ({ theme, transparentSurface }) => ({
        flexGrow: 1,
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        background: transparentSurface ? 'unset' : theme.color.white,
        borderRadius: theme.borderRadius.base,
    })
);

export default PageCard;
